export const EMAIL_REGEX = /\S+@\S+\.\S+/;

// Source to check https://ihateregex.io/expr/password/
export const PASSWORD_REGEX =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{6,}$/;

export const PHONENUMBER_REGEX = /^\+?[0-9][0-9]*$/;
